import styled from "styled-components/macro";
import type { IconProps } from "./Icon.model";

export const StyledIcon = styled.i<IconProps>`
  font-size: 20px;
`;
